module.exports = __webpack_public_path__ + "img/1961.10b53178.svg";